import * as React from 'react'
import MUIAvatar from '@mui/material/Avatar'

const Avatar = (props) => <MUIAvatar {...props} />

export default Avatar
